import React from 'react';
import {
    Sidebar,
    SidebarButton,
    SectionTitle,
    Dropdown,
    DropdownOption,
    PriorityIndicator,
    NextStatusButton
} from '../../styles/CardModal.styles';
import { PRIORITY_LABELS, PRIORITY_LEVELS } from '../../constants/cardConstants';
import { exportCardAsJson } from '../../utils/projectExportUtils';

import AssigneePicker from '../AssigneePicker'

const CardSidebar = ({
    setShowLabelPicker,
    handleAddChecklist,
    showAssigneePicker,
    setShowAssigneePicker,
    showStatusDropdown,
    setShowStatusDropdown,
    showPriorityDropdown,
    setShowPriorityDropdown,
    selectedStatus,
    selectedPriority,
    allColumns,
    handleNextStatus,
    assignee,
    cardData,
    handleArchiveCard,
    handleDuplicateCard,
    onClose,
    setShowDeleteConfirmation,
    handleStatusChange,
    handlePriorityChange,
    projectMembers,
    handleAssign,
    handleUnassign, // Added missing prop
    columnOrder,
    onToggleDueDatePopover,
    onToggleStartDatePopover,
    onOpenMoveCardModal, // New prop for opening the move card modal
    isLoadingWorkspaceId, // New prop for loading state
    // Cover image props
    onShowCoverImagePopover,
    // Export props
    columnTitle,
    projectLabels,
    projectMembers: sidebarProjectMembers,
}) => {
    const NextStatusIcon = () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            // style={{ marginLeft: '8px', cursor: 'pointer' }} // Style will be handled by NextStatusButton
        >
            <path d="M5 12h14" />
            <path d="M12 5l7 7-7 7" />
        </svg>
    );

    return (
        <Sidebar>
            <SectionTitle>Add to card</SectionTitle>

            <SidebarButton onClick={() => setShowLabelPicker(true)}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
                    <line x1="7" y1="7" x2="7.01" y2="7" />
                </svg>
                Labels
            </SidebarButton>

            <SidebarButton onClick={handleAddChecklist}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M9 11l3 3L22 4" />
                    <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
                </svg>
                Checklist
            </SidebarButton>

            <div style={{ position: 'relative' }}>
                <SidebarButton onClick={() => setShowAssigneePicker(!showAssigneePicker)}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                        <circle cx="12" cy="7" r="4" />
                    </svg>
                    {assignee ? 'Change Assignee' : 'Assign'}
                </SidebarButton>
                {showAssigneePicker && (
                    <AssigneePicker
                        members={projectMembers}
                        onAssign={handleAssign}
                        onUnassign={handleUnassign} // Pass handleUnassign
                        assignee={assignee} // Pass current assignee
                        onClose={() => setShowAssigneePicker(false)}
                    />
                )}
            </div>

            <SidebarButton onClick={onToggleStartDatePopover}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                    <line x1="16" y1="2" x2="16" y2="6"></line>
                    <line x1="8" y1="2" x2="8" y2="6"></line>
                    <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
                Start Date
            </SidebarButton>

            <SidebarButton onClick={onToggleDueDatePopover}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                    <line x1="16" y1="2" x2="16" y2="6"></line>
                    <line x1="8" y1="2" x2="8" y2="6"></line>
                    <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
                Due Date
            </SidebarButton>

            <SidebarButton onClick={onShowCoverImagePopover}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                    <circle cx="8.5" cy="8.5" r="1.5"></circle>
                    <polyline points="21 15 16 10 5 21"></polyline>
                </svg>
                Cover
            </SidebarButton>

            <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                <SidebarButton onClick={() => setShowStatusDropdown(!showStatusDropdown)} style={{ flexGrow: 1 }}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
                    </svg>
                    {allColumns[selectedStatus]?.title}
                </SidebarButton>
                <NextStatusButton onClick={handleNextStatus}>
                    <NextStatusIcon />
                </NextStatusButton>
                {showStatusDropdown && (
                    <Dropdown>
                        {columnOrder.map(columnId => {
                            const col = allColumns[columnId];
                            if (!col) return null;
                            return (
                                <DropdownOption
                                    key={col.id}
                                    selected={col.id === selectedStatus}
                                    onClick={() => handleStatusChange(col.id)}
                                >
                                    {col.title}
                                </DropdownOption>
                            );
                        })}
                    </Dropdown>
                )}
            </div>

            <div style={{ position: 'relative' }}>
                <SidebarButton onClick={() => setShowPriorityDropdown(!showPriorityDropdown)}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
                    </svg>
                    Priority: {PRIORITY_LABELS[selectedPriority]?.label}
                </SidebarButton>
                {showPriorityDropdown && (
                    <Dropdown>
                        {Object.entries(PRIORITY_LEVELS).map(([key, value]) => (
                            <DropdownOption
                                key={value}
                                selected={value === selectedPriority}
                                onClick={() => handlePriorityChange(value)}
                            >
                                <PriorityIndicator priority={value}>
                                    {PRIORITY_LABELS[value]?.label}
                                </PriorityIndicator>
                            </DropdownOption>
                        ))}
                    </Dropdown>
                )}
            </div>

            <SectionTitle>Actions</SectionTitle>

            <SidebarButton onClick={onOpenMoveCardModal} disabled={isLoadingWorkspaceId}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                    <line x1="12" y1="3" x2="12" y2="21"></line>
                    <line x1="3" y1="12" x2="21" y2="12"></line>
                    <polyline points="12 17 7 12 12 7"></polyline>
                    <polyline points="17 12 12 17 7 12"></polyline>
                </svg>
                Move Card
            </SidebarButton>

            <SidebarButton onClick={async () => {
                await handleDuplicateCard();
            }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M16 16v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2m5.66 0H14a2 2 0 0 1 2 2v3.34l1 1L23 7v10" />
                    <line x1="1" y1="1" x2="23" y2="23" />
                </svg>
                Duplicate
            </SidebarButton>

            <SidebarButton onClick={async () => {
                await handleArchiveCard();
                onClose();
            }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 8v13H3V8" />
                    <path d="M1 3h22v5H1z" />
                    <path d="M10 12h4" />
                </svg>
                {cardData.archived ? 'Send to board' : 'Archive'}
            </SidebarButton>

            <SidebarButton onClick={() => exportCardAsJson(cardData, { columnTitle, projectLabels, projectMembers: sidebarProjectMembers })}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="7 10 12 15 17 10" />
                    <line x1="12" y1="15" x2="12" y2="3" />
                </svg>
                Export as JSON
            </SidebarButton>

            <SidebarButton
                onClick={() => setShowDeleteConfirmation(true)}
                style={{
                    background: '#FF5630',
                    color: 'white'
                }}
            >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M3 6h18" />
                    <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
                    <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
                </svg>
                Delete card
            </SidebarButton>
        </Sidebar>
    );
};

export default CardSidebar;
